<template>
  <section-page
    title="Calendar Settings"
    description="Settings for sharing tasks to calendar"
    is-short
  >
    <app-upgrade-required v-if="!hasCalendarFeature" />

    <template v-else-if="!isGoogleCalendarIntegrated">
      <app-empty-message
        :count="0"
        heading="Please set up your calendar integration in order to start sharing tasks to calendar."
        :is-empty-boxed="false"
      />
    </template>

    <template v-else>
      <grid-row class="my-100 px-75">
        <form-field-switch
          class="mb-25"
          label="Sync to Calendar"
          v-model="form.is_task_push_calendar"
          size=""
          help-text="Turn on this switch to sync tasks to your calendar. Only newly created tasks will be synced."
        />
      </grid-row>

      <div class="flex flex-end save-btn-container">
        <button-outlined @click="save" :loading="isSaving"
          >Save Settings
        </button-outlined>
      </div>
    </template>
  </section-page>
</template>

<script>
import api from "../../../api";
import AppUpgradeRequired from "../../../components/app/AppUpgradeRequired.vue";
export default {
  name: "TaskCalendarSetting",
  components: { AppUpgradeRequired },
  data() {
    return {
      isSaving: false,
      form: {
        is_task_push_calendar: false,
      },
    };
  },
  mounted() {
    this.form = {
      is_task_push_calendar: this.account.is_task_push_calendar,
    };
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    hasCalendarFeature() {
      return this.$store.state.accounts.features.CalendarIntegration;
    },
    isGoogleCalendarIntegrated() {
      return this.$store.getters.googleCalendarIsIntegrated;
    },
  },
  methods: {
    save() {
      this.isSaving = true;
      api.accounts
        .updateTaskCalendarSettings(this.account.id, this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Task calendar settings have been saved",
            type: "is-success",
          });
        })
        .finally(() => (this.isSaving = false));
    },
  },
};
</script>

<style scoped lang="scss"></style>
